module.exports = __webpack_public_path__ + "static/media/mod-fragaria.9c62323d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/mod-fragaria.jpg
// module id = 332
// module chunks = 0